import { z } from 'zod'

const LocationQtySchema = z.object({
  location: z.string(),
  qty: z.number(),
})

const ItemSchema = z.object({
  id: z.number(),
  seq: z.number(),
  itemId: z.number(),
  lotNo: z.string(),
  mold: z.string(),
  unit: z.string(),
  qty: z.number(),
  refNo: z.string().nullish(),
  refId: z.number().nullish(),
  refItemId: z.number().nullish(),
  itemRefType: z.number().nullish(),
  toLocations: z.array(LocationQtySchema),
})

export const Inv1015GetResultSchema = z.object({
  number: z.string(),
  date: z.string(),
  partyId: z.number(),
  refNo: z.string(),
  refDate: z.string(),
  remark: z.string().nullish(),
  items: z.array(ItemSchema),
  status: z.number(),
})

export type Inv1015GetResultModel = z.input<typeof Inv1015GetResultSchema>
